// extracted by mini-css-extract-plugin
export default {"root":"ContainedTable_root__NPpCZ","table":"ContainedTable_table__nP+kn"};